module.exports = __webpack_public_path__ + "img/icon_support_04.63d7f0ea.png";